<template>
  <!-- Header -->
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div class="content-header-section">
        <!-- Toggle Sidebar -->
        <button type="button" class="btn btn-circle btn-dual-secondary" @click="toggleSidebar">
          <i class="fa fa-navicon"></i>
        </button>
        <!-- END Toggle Sidebar -->

        <nav class="breadcrumb">
          <router-link :to="{name: 'dashboard'}" class="breadcrumb-item"><i class="fa fa-home"></i></router-link>
          <span class="breadcrumb-item">Magazijn</span>
          <span class="breadcrumb-item">Producten</span>
        </nav>

      </div>
      <!-- END Left Section -->

      <!-- Right Section -->
      <div class="content-header-section">

        <!-- User Dropdown -->
        <b-dropdown :text="user.username" variant="dual-secondary" right>
          <b-dropdown-item :to="{name: 'settings'}">
            <i class="si si-wrench mr-5"></i> Instellingen
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logout">
            <i class="si si-logout mr-5"></i> Log uit
          </b-dropdown-item>
        </b-dropdown>
        <!-- END User Dropdown -->
      </div>
      <!-- END Right Section -->
    </div>
    <!-- END Header Content -->

  </header>
  <!-- END Header -->
</template>

<script>
export default {
  data () {
    return {
      user: this.$auth.getUser()
    }
  },
  methods: {
    logout () {
      this.$auth.logout()
      this.$router.push({ name: 'login' })
    },
    toggleSidebar () {
      this.$emit('toggle-sidebar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?6e5c5a97